import React, { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { ActionMenuItem } from '@atlassian/jira-release-flyout/src/ui/actions-menu/index.tsx';
import { RELEASES_IN_CALENDAR_SUPPORT_ARTICLE } from '../../../../common/constants.tsx';
import { messages } from './messages.tsx';

export const LearnMoreItem = ({ onClosePopup }: { onClosePopup: () => void }) => {
	const { formatMessage } = useIntl();

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClick = useCallback(() => {
		if (typeof window !== 'undefined') {
			window.open(RELEASES_IN_CALENDAR_SUPPORT_ARTICLE, '_blank');
		}
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'infoLink',
			}),
			'releaseFlyout',
		);
		onClosePopup();
	}, [createAnalyticsEvent, onClosePopup]);

	return <ActionMenuItem onClick={onClick}>{formatMessage(messages.learnMore)}</ActionMenuItem>;
};
